
const rules = {
    name: [
        name => !!name || "Cannot be blank",
    ],

    phone: [
        phone => !!phone || "Phone is required",
        phone => (!!phone && phone.length > 9) || "Phone number should be at least 10 digits"
    ],

    phone_optional: [
        phone => (!phone || phone.length > 9) || "Phone number should be at least 10 digits"
    ],

    zip_optional: [
        zip => !zip || /^\d{5}$/.test(zip) || "Zip is not valid"
    ],

    email: [
        email => /.+@.+/.test(email) || "Email must be valid"
    ],

    email_optional: [
        email => (!email || /.+@.+/.test(email)) || "Email must be valid"
    ],

    password: [
        password => !!password || "Password is required",
        password =>
            (!!password && password.length >= 8) || "Password should be at least 8 characters"
    ],

    money: [
        money => !!money || "Rate cannot be empty",
        money => /^[1-9](\d*)(\.?)(\d*)$/.test(money) || +money >= 0 || "Not a valid rate"
    ]
    
};

export default rules
